import { render, staticRenderFns } from "./ClientShow.vue?vue&type=template&id=4430dee2&scoped=true"
import script from "./ClientShow.vue?vue&type=script&lang=js"
export * from "./ClientShow.vue?vue&type=script&lang=js"
import style0 from "./ClientShow.vue?vue&type=style&index=0&id=4430dee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4430dee2",
  null
  
)

export default component.exports